import React, { useEffect, useRef, useState } from 'react'
import TablesContainer from '../components/TablesContainer/TablesContainer'
import Banner from '../components/Banner/Banner'
import { useDispatch, useSelector } from 'react-redux'
import { ReducerUser, Reducers } from '../types/reducers'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../resources/routes-constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faUser } from '@fortawesome/free-solid-svg-icons'
import betaTag from '../resources/images/fmw-beta-tag.png'
import { handleDropdownClick } from '../utility/functions'
import { logoutUser } from '../store/actions/user'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

const HomePage: React.FC = () => {
    const user = useSelector<Reducers, ReducerUser>((state) => state.user)
    const [alertMessage, setAlertMessage] = useState('')
    const [userProfilePanelIsOpen, setUserProfilePanelIsOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const userProfileTrigger = useRef(null)
    const userProfilePanel = useRef(null)
    const dispatch = useDispatch()
    const { t } = useTranslation()

    useEffect(() => {
        window.addEventListener('click', (e) => {
            setUserProfilePanelIsOpen(
                (userProfilePanelIsOpen) =>
                    (userProfilePanelIsOpen = handleDropdownClick(
                        e,
                        userProfilePanelIsOpen,
                        userProfileTrigger,
                        userProfilePanel
                    ))
            )
        })
        return () => {
            window.removeEventListener('click', (e) => {
                setUserProfilePanelIsOpen(
                    (userProfilePanelIsOpen) =>
                        (userProfilePanelIsOpen = handleDropdownClick(
                            e,
                            userProfilePanelIsOpen,
                            userProfileTrigger,
                            userProfilePanel
                        ))
                )
            })
        }
    }, [])

    useEffect(() => {
        if (!user.userInfo || !user.userInfo.uuid || !user.authToken) {
            navigate(ROUTES.PUBLIC_HOMEPAGE_ROUTE)
        }
    }, [user])

    const getPreviousDay = (date = new Date()) => {
        const previous = new Date(date.getTime())
        previous.setDate(date.getDate() - 1)
        return previous
    }

    useEffect(() => {
        if (!alertMessage) return
        setTimeout(() => {
            setAlertMessage('')
        }, 5000)
    }, [alertMessage])

    const requestAccountDeletion = async () => {
        setIsLoading(true)
        try {
            if (!user.userInfo || !user.userInfo.uuid || !user.authToken) return
            await axios.post(
                `https://api.peperoni.ai/22sso-api/users/${user.userInfo.uuid}/request-deletion`,
                {},
                {
                    headers: { Authorization: `Bearer ${user.authToken}` },
                }
            )
            setAlertMessage(t('errors.success_request_profile_deletion').toString())
        } catch (error) {
            console.error(error)
            setAlertMessage(t('errors.error_during_request_profile_deletion').toString())
        }
        setIsLoading(false)
    }

    const startLogoutProcedure = async () => {
        try {
            await dispatch(logoutUser())
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className="main-container">
            {alertMessage && <div className="alert-message-container">{alertMessage}</div>}
            <div className="header-container">
                <div className="header-container__left-section">
                    <div className="header-container__left-section__top-row">
                        <span className="main-title">FM-world charts</span>
                        <div className="beta-tag-image-container">
                            <img src={betaTag} alt="FM-world BETA" />
                        </div>
                    </div>
                    <span className="main-subtitle">Le radio più ascoltate sull&apos;app di FM-world</span>
                    <span className="main-subtitle">
                        Dati relativi al giorno {getPreviousDay().toLocaleDateString('it')}
                    </span>
                </div>
                <div className="header-container__right-section">
                    <div className="user-identity-chip">
                        <FontAwesomeIcon icon={faUser} />
                        <span>{user.userInfo?.username}</span>
                    </div>
                    <div className="user-profile-actions-selector">
                        <div
                            ref={userProfileTrigger}
                            className={`action-selector ${userProfilePanelIsOpen ? 'main-selector-open' : ''} `}
                        >
                            <div className="icon">
                                <FontAwesomeIcon icon={faChevronDown} />
                            </div>
                        </div>
                        {userProfilePanelIsOpen && (
                            <div ref={userProfilePanel} className="main-profile-actions-panel">
                                <div className="user-profile-actions-list">
                                    <p onClick={() => void startLogoutProcedure()}>Esci</p>
                                    <p
                                        onClick={() => {
                                            if (isLoading) return
                                            void requestAccountDeletion()
                                        }}
                                    >
                                        {isLoading ? 'Invio richiesta in corso...' : 'Richiedi eliminazione account'}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="horizontal-divider" />
            <span className="time-span-section-title">Ultima ora</span>
            <TablesContainer chartTimeSpan="last_hour" needsToken hideTvChart token={user.authToken} />
            <div className="horizontal-divider" />
            <Banner />
            <span className="time-span-section-title">Ultimo giorno</span>
            <TablesContainer chartTimeSpan="last_day" needsToken token={user.authToken} />
            <div className="horizontal-divider" />
            <span className="time-span-section-title">Ultimo mese</span>
            <TablesContainer chartTimeSpan="last_month" needsToken token={user.authToken} hasMoreThanTenElements />
        </div>
    )
}

export default HomePage
